/* Actividad.ts */
import { AxiosInstance as ApiInstance } from 'axios'
class ActividadService {
  API: ApiInstance
  page = 1

  constructor (api: ApiInstance) {
    this.API = api
  }

  async getListar (): Promise<{ actividadListarData: any; actividadCursosData: any }> {
    try {
      const [actividadListarResponse, actividadCursosResponse] = await Promise.all([
        this.API.get('/api/actividad/listar'),
        this.API.get('/api/actividad/cursos')
      ])
      const actividadListarData = actividadListarResponse.data
      const actividadCursosData = actividadCursosResponse.data
      const combinedData = {
        actividadListarData,
        actividadCursosData
      }

      return combinedData
    } catch (error: any) {
      const responseData = (error.response && error.response.data) || 'Unknown error'
      throw new Error(JSON.stringify(responseData))
    }
  }

  async actividadesid (id: number, activityScheduleId: number) {
    try {
      const response = await this.API.post(`/api/actividad/${id}/${activityScheduleId}`)
      const { data } = response
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response.data))
    }
  }

  async cursoid (id: number) {
    try {
      const response = await this.API.post(`/api/curso/${id}`)
      const { data } = response
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response.data))
    }
  }

  async actividadesCurso (id: number) {
    try {
      const response = await this.API.post(`/api/actividades/${id}`)
      const { data } = response
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response.data))
    }
  }

  async Listar () {
    try {
      const { data } = await this.API.get('/api/actividades/user')
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response.data))
    }
  }

  async check (activityScheduleId: number, value: number) {
    try {
      const { data } = await this.API.post(`/api/actividades/check/${activityScheduleId}/${value}`)
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response.data))
    }
  }
}

export default ActividadService
